// Application Configuration
// This file contains all configurable values for the application
// Source location: app/.config/config.js (for reference)

// Backend URL configuration
// Backend runs on port 8000 with HTTPS
export const CONFIG = {
    // Backend API Configuration
    BACKEND_BASE_URL: 'https://sir.amfm.pt:8000',
    BACKEND_API_PATH: '/api/v1',
    
    // Computed values
    get BACKEND_URL() {
        return `${this.BACKEND_BASE_URL}${this.BACKEND_API_PATH}`;
    }
};
